import { createContext } from 'react';
export const HistoryContext = createContext({});
